<app-input-field
  [form]="form"
  type="password"
  [id]="id"
  [controlName]="controlName"
  [key]="key"
  [class]="class"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [hideLabel]="hideLabel"
  [hideErrors]="hideErrors"
></app-input-field>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/forms/input-password-field/input-password-field.component.html